import React from 'react';
import { Link } from 'react-router-dom';
import { Brain } from 'lucide-react';
import Container from '../ui/Container';

const Footer: React.FC = () => {
  return (
    <footer className="bg-background border-t border-neutral-800">
      <Container>
        <div className="py-12 md:py-16">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12">
            {/* Company Info */}
            <div className="md:col-span-8">
              <Link to="/" className="flex items-center space-x-2 mb-2 group">
                <div className="relative w-8 h-8">
                  <Brain 
                    size={32} 
                    className="absolute top-0 left-0 text-primary transform transition-all duration-500 ease-bounce group-hover:scale-125 group-hover:-translate-y-2"
                    strokeWidth={1.5}
                  />
                  <Brain 
                    size={32} 
                    className="absolute top-0 left-0 text-accent opacity-0 transform scale-90 -rotate-12 transition-all duration-500 ease-bounce group-hover:opacity-50 group-hover:translate-x-2 group-hover:translate-y-2"
                    strokeWidth={1.5}
                  />
                </div>
                <span className="text-2xl font-bold">Product Leap AI</span>
              </Link>
              <p className="text-sm text-primary font-medium mb-4">Building AI Strategies, Together!</p>
              <p className="text-neutral-300 mb-6">
                Turning AI Ideas into Market-Ready Products. We help businesses navigate the complexities of AI product development.
              </p>
              <div className="flex space-x-4">
                <a 
                  href="https://x.com/ProductLeapAI" 
                  className="text-neutral-400 hover:text-primary transition-colors"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <svg width="24" height="24" viewBox="0 0 1200 1227" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z" fill="currentColor"/>
                  </svg>
                </a>
                <a 
                  href="https://www.linkedin.com/company/productleap-ai" 
                  className="text-neutral-400 hover:text-primary transition-colors"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path>
                    <rect x="2" y="9" width="4" height="12"></rect>
                    <circle cx="4" cy="4" r="2"></circle>
                  </svg>
                </a>
              </div>
            </div>
            
            {/* Quick Links */}
            <div className="md:col-span-4">
              <h3 className="text-lg font-semibold mb-4">Company</h3>
              <ul className="space-y-2">
                <li><Link to="/about" className="text-neutral-300 hover:text-primary transition-colors">About Us</Link></li>
                <li><Link to="/services" className="text-neutral-300 hover:text-primary transition-colors">Services</Link></li>
                <li><Link to="/faq" className="text-neutral-300 hover:text-primary transition-colors">FAQ</Link></li>
              </ul>
            </div>
          </div>
        </div>
        
        <div className="py-6 border-t border-neutral-800">
          <div className="text-neutral-400 text-sm space-y-4">
            <p className="text-justify">
              Product Leap AI is a collaboration between ProdAI Consulting and Product Leap. ProdAI Consulting - Sole proprietorship registered with the Dutch Chamber of Commerce | KvK: 97068004. Product Leap - Sole proprietorship registered with the Dutch Chamber of Commerce | KvK: 97343137.
            </p>
            <div className="flex flex-col md:flex-row justify-between items-center gap-4">
              <p>© {new Date().getFullYear()} Product Leap AI. All rights reserved.</p>
              <div>
                <Link to="/privacy-policy" className="text-neutral-400 hover:text-primary transition-colors">
                  Privacy Policy
                </Link>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;